import React, { Fragment } from 'react';
import Capacitation from './components/Capacitation';

const AcademyComponent = () => {
  return (
    <Fragment>
      <Capacitation />
    </Fragment>
  );
};

export default AcademyComponent;
